import { getUnitPriceString } from "lib";

import { isSold } from "lib/saleLot";

interface MergeableSaleLot {
  buyer_id?: string | null;
  buyer_way?: { id?: number | string | null; name?: string } | null;
  pricing_type_id: number;
  quantity: number;
  total_mass_grams: number;
  total_price_cents: number;
  vendor_id: string;
}

export const isMergeableSaleLotSold = (saleLot: MergeableSaleLot): boolean =>
  isSold(saleLot.buyer_id, saleLot.vendor_id);

const getSaleDetailsKey = (saleLot: MergeableSaleLot): string =>
  [
    saleLot.buyer_id,
    saleLot.buyer_way?.name ?? "",
    saleLot.pricing_type_id,
    getUnitPriceString(saleLot),
  ].join("|");

// Merging keeps only the kept lot's buyer and price, so differing sold lots need a warning.
export const getConflictingSoldSaleLots = <T extends MergeableSaleLot>(
  saleLots: T[],
): T[] => {
  const soldSaleLots = saleLots.filter(isMergeableSaleLotSold);
  const saleDetailsKeys = new Set(soldSaleLots.map(getSaleDetailsKey));
  return saleDetailsKeys.size > 1 ? soldSaleLots : [];
};

export const getSoldSaleLotsMergedIntoUnsold = <T extends MergeableSaleLot>(
  fromSaleLots: T[],
  toSaleLot: T,
): T[] =>
  isMergeableSaleLotSold(toSaleLot)
    ? []
    : fromSaleLots.filter(isMergeableSaleLotSold);
